module.exports = __webpack_public_path__ + "static/img/tixbay-title.f52f0a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/tixbay-title.png
// module id = 2034
// module chunks = 148